<template>
  <div class="agents">
    <toolbar
      backRoute="/dashboard"
      title="Handlers and Agents"
      :addButton="true"
      addButtonLabel="Add handler/agent"
      addButtonRoute="/dashboard/agents/new" />

    <d-row class="mt-5">
      <d-col cols="12" class="d-flex">
        <d-input
          v-model="filters.search"
          placeholder="Search handlers"
          @keyup.native.enter="saveFilters" />
        <d-button
          theme="primary"
          outline
          class="ml-2"
          @click.prevent="saveFilters">
          Search
        </d-button>
        <d-button
          v-if="filters.search !== ''"
          theme="danger"
          outline
          class="ml-2"
          @click.prevent="resetFilters">
          Reset
        </d-button>
      </d-col>
    </d-row>

    <table class="table table-striped table-bordered table-hover mt-5">
      <thead>
        <tr>
          <sortable-table-heading field="name" view="handlers" :column="orderColumn" :direction="orderDirection">Name</sortable-table-heading>
          <sortable-table-heading field="phone" view="handlers" :column="orderColumn" :direction="orderDirection">Phone number</sortable-table-heading>
          <sortable-table-heading field="email" view="handlers" :column="orderColumn" :direction="orderDirection">Email</sortable-table-heading>
          <th>Agent</th>
          <th>FBO</th>
          <th>Notes</th>
          <th>Actions</th>
        </tr>
      </thead>

      <tbody v-if="!loadError">
        <tr v-if="!allDataLoaded">
          <td
            colspan="7"
            class="text-center">
            Loading handlers and agents&hellip;
          </td>
        </tr>
        <tr v-if="allDataLoaded && handlers.length === 0">
            <td
              colspan="7"
              class="text-center">
              There are no handlers/agents to display&hellip;
            </td>
          </tr>
        <tr
          v-for="(agent, index) of handlers"
          :key="'agent-' + index">
          <td class="align-middle" style="width: 240px;">
            {{ agent.name }}
            <template v-if="agent.website">
              <br><small><a :href="agent.website">{{ agent.website }}</a></small>
            </template>
          </td>
          <td class="align-middle" style="width: 180px;"><a :href="'tel:' + agent.phone"><small>{{ agent.phone }}</small></a></td>
          <td class="align-middle" style="width: 160px;"><a :href="'mailto:' + agent.email"><small>{{ agent.email }}</small></a></td>
          <td class="align-middle text-center" style="width: 60px;"><template v-if="agent.type === 'AGENT'"><i class="material-icons text-success">check_circle</i></template></td>
          <td class="align-middle text-center" style="width: 60px;"><template v-if="agent.fbo"><i class="material-icons text-success">check_circle</i></template></td>
          <td class="align-middle"><small>{{ agent.notes }}</small></td>
          <td class="align-middle" style="width: 140px;">
            <d-button
              theme="primary"
              @click.native="$router.push('/dashboard/agents/' + agent.id)"
              class="mr-2"
              title="Edit agent/handler">
              <i class="material-icons">edit</i>
            </d-button>
            <d-button
              theme="danger"
              :disabled="removeInProgress"
              @click.prevent="removeAgent(agent.id)"
              title="Remove agent/handler">
              <i class="material-icons">delete</i>
            </d-button>
          </td>
        </tr>
      </tbody>
    </table>

    <d-alert
      v-if="loadError"
      show
      theme="warning">
      An error occurred during data loading. <a href="javascript:window.location.reload();" class="alert-link">Reload the page</a> to try again.
    </d-alert>

    <pagination :meta-data="paginationMetaData" />
  </div>
</template>

<script>
import HasFilters from './../mixins/HasFilters.vue';
import HasPagination from './../mixins/HasPagination.vue';
import ListUtils from './../utils/ListUtils.js';
import Pagination from './../components/common/Pagination.vue';
import SortableTableHeading from './../components/common/SortableTableHeading.vue';

export default {
  name: 'handlers',
  mixins: [
    HasFilters,
    HasPagination
  ],
  components: {
    'pagination': Pagination,
    'sortable-table-heading': SortableTableHeading
  },
  computed: {
    allDataLoaded () {
      return this.loaded;
    }
  },
  data () {
    return {
      loaded: false,
      handlers: null,
      loadError: false,
      removeInProgress: false
    };
  },
  mounted () {
    this.loadFilteredData();
  },
  methods: {
    removeAgent (agentID) {
      this.removeInProgress = true;

      ListUtils.removeItem({
        $http: this.$http,
        endpointBase: '/handlers/delete/',
        id: agentID,
        successTitle: 'Agent removed',
        successText: 'The selected agent has been removed',
        confirmTitle: 'Do you really want to remove this agent?',
        confirmText: 'This operation cannot be reverted',
        errorTitle: 'An error occurred',
        errorText: 'Please try again.',
        successAction: () => {
          this.removeInProgress = false;
          this.loadFilteredData();
          this.$bus.$emit('calendar-reload-handlers');
        },
        cancelAction: () => {
          this.removeInProgress = false;
        }
      });
    }
  }
};
</script>

<style lang="scss">

</style>
